/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import usePageDesigner from '@consteed/frontend/utils/use-page-designer'

// Components
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

//Hooks
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'

// Constants
import {MAX_CACHE_AGE} from '../../constants'

import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {useSelectRoleContext} from '@consteed/frontend/hooks/use-select-role-modal'

/**
 * This is the home page for Retail React App.
 * The page is created for demonstration purposes.
 * The page renders SEO metadata and a few promotion
 * categories and products, data is from local file.
 */
const Home = () => {
    const einstein = useEinstein()
    const {pathname} = useLocation()
    const pageDesignerPage = usePageDesigner({pageId: 'home'})
    const {onOpen: onSelectRoleOpen} = useSelectRoleContext()

    // useServerContext is a special hook introduced in v3 PWA Kit SDK.
    // It replaces the legacy `getProps` and provide a react hook interface for SSR.
    // it returns the request and response objects on the server side,
    // and these objects are undefined on the client side.
    const {res} = useServerContext()
    if (res) {
        res.set('Cache-Control', `s-maxage=${MAX_CACHE_AGE}`)
    }

    /**************** Einstein ****************/
    useEffect(() => {
        einstein.sendViewPage(pathname)
    }, [])
    /**************** Select Role Modal ****************/
    useEffect(() => {
        onSelectRoleOpen({isEdit: false})
    }, [])

    return <Box data-testid="home-page">{pageDesignerPage}</Box>
}

Home.getTemplateName = () => 'home'

export default Home
